import { inject, observer } from 'mobx-react';
import React from 'react'

@inject('workAreaStore') @observer
class FontSlide extends React.Component {

  constructor(props){
    super(props)
    this.state = {
      value: 'arial',
      id: ''
    }
  }

  selectFont(id, family){
    this.setState({ value: family, id })
    this.props.workAreaStore.setChanged(true)
  }

  componentDidUpdate(p, prevState){
    if(this.state.value !== prevState.value){
      const layer = this.props.workAreaStore.getSelectedLayer()
      const idHash = btoa(layer.id)
      const btnSelector = `#text-toolbar-${idHash} .ql-changeFont`
      const btn = document.querySelector(btnSelector)
      btn.click()
    }
  }

  render(){
    const { workAreaStore: { loadedFonts, fontsLoading }, fontSearch } = this.props
    const empty = (!fontsLoading && loadedFonts.length === 0) || (!fontsLoading && !this.props.workAreaStore.moreFonts && !fontSearch.length && loadedFonts.length)
    return (
      <div className='col-12'>
        {
          loadedFonts && loadedFonts.length ? (
            loadedFonts.map((font, idx) => (
              font ? (
                <div className='row' key={font.id + idx}>
                  <div className='col-12 font-col' onClick={() => this.selectFont(font.id, font.family)}>
                    <img className='font-preview' src={font.previewURL} />
                  </div>
                </div>
              )
              :
              undefined
            ))
          )
          :
          undefined
        }
        {
          empty ? (
            <div className='text-style-slide__font-tools__empty'>
              <span>No fonts</span>
              <label className='gray'>{fontSearch.length ? 'Try searching for something else' : 'All fonts loaded'}</label>
            </div>
          )
          :
          undefined
        }
        {
          fontsLoading ? (
            <div className='text-style-slide__font-tools__loading-wrapper'>
              <img src="https://mediamodifier.com/gfx/mm-logo.svg" className='logo-loader'/>
            </div>
          ) : undefined
        }
        <input className='font-change-value' readOnly value={this.state.value} style={{display: 'none'}} />
        <input className='font-change-id' readOnly value={this.state.id} style={{display: 'none'}} />
      </div>
    )
  }

}

export default FontSlide